import { useCaeInfo } from '../../../hooks/useAfip';

export const useInvoiceQuery = ({ salePointNumber, voucherNumber }, options = {}) => {
  return useCaeInfo({ salePointNumber, voucherNumber }, options);
};
